module.exports = __webpack_public_path__ + "img/message.c52da189.png";